import { CompareRule, RequiredRule, Validator } from "devextreme-react/validator";
import { useContext } from 'react';
import { Field } from '../../../../layouts';
import { AR, OrderStatus, ScriptFileType } from '../../../../types/enums';
import { formatShortDate } from '../../../../utils/date-utils';
import { DateBox } from "devextreme-react";
import CallScriptComp from "../../call-script/component/CallScriptComp";
import { RefetchScope, RetailOrderContext } from '../context/RetailOrderContext';

export default function SchedulePlumbingDates() {

	const { order, modifyOrder,refetchOrder } = useContext(RetailOrderContext);

	const isOrderReadonly =
		order.details.orderStatusID === OrderStatus.Closed ||
		order.details.orderStatusID === OrderStatus.Cancelled ||
		order.details.orderStatusID === OrderStatus.Pending;

	const disconnectDateRequired = order.details.activeARs.includes(AR.ScheduleDisconnect);
	const reconnectDateRequired = order.details.activeARs.includes(AR.ScheduleReconnect);

	return (
		<>
			<Field label="Ready for Disconnect Date">
				<DateBox value={order.details.readyForDisconnectDate}
					onValueChanged={(e) => modifyOrder({ ...order.details, readyForDisconnectDate: e.value })}
					readOnly={isOrderReadonly || order.details.disablePlumbingReadyForDates}>
					<Validator>
						<CompareRule
							ignoreEmptyValue={true}
							comparisonTarget={() => { return order.details.readyForReconnectDate ?? new Date('9999-01-01'); }}
							comparisonType="<="
							message="Ready for Disconnect Date cannot be later than Ready for Reconnect Date"
						/>
					</Validator>
				</DateBox>
			</Field>
			<Field label="Ready for Reconnect Date">
				<DateBox value={order.details.readyForReconnectDate}
					onValueChanged={(e) => modifyOrder({ ...order.details, readyForReconnectDate: e.value })}
					readOnly={isOrderReadonly || order.details.disablePlumbingReadyForDates}>
					<Validator>
						<CompareRule
							ignoreEmptyValue={true}
							comparisonTarget={() => { return order.details.readyForDisconnectDate ?? new Date('0000-01-01'); }}
							comparisonType=">="
							message="Ready for Reconnect Date cannot be earlier than Ready for Disconnect Date"
						/>
					</Validator>
				</DateBox>
			</Field>

			<Field label={'Countertop Install Date'}>
				{formatShortDate(order.details.countertopInstallDate)}
			</Field>
			<Field label={'Scheduled Disconnect Date'}>
				<DateBox value={order.details.scheduledDisconnectDate}
					onValueChanged={(e) => modifyOrder({ ...order.details, scheduledDisconnectDate: e.value })}
					readOnly={isOrderReadonly}
					className={disconnectDateRequired ? 'required' : ''}>
					<Validator>
						{
							disconnectDateRequired &&
							<RequiredRule message={'Scheduled Disconnect Date is required'} />

						}
						<CompareRule
							ignoreEmptyValue={true}
							comparisonTarget={() => { return order.details.scheduledReconnectDate ?? new Date('9999-01-01'); }}
							comparisonType="<="
							message="Scheduled Disconnect Date cannot be later than Scheduled Reconnect Date"
						/>
					</Validator>
				</DateBox>
				<CallScriptComp
					fileType={ScriptFileType.PlumbingSchedule}
					retailOrderID={order.details.retailOrderID}
					retailOrderNumber={order.details.roNumber}
					fileName={"Sage Plumbing Call Script Schedule Disconnect Reconnect"}
					fileAttachment={order.details.files}
					submitCallback={() => refetchOrder(RefetchScope.Files)}
				/>
			</Field>
			<Field label={'Scheduled Reconnect Date'}>
				<DateBox value={order.details.scheduledReconnectDate}
					onValueChanged={(e) => modifyOrder({ ...order.details, scheduledReconnectDate: e.value })}
					readOnly={isOrderReadonly}
					className={reconnectDateRequired ? 'required' : ''}>
					<Validator>
						{
							reconnectDateRequired &&
							<RequiredRule message={'Scheduled Reconnect Date is required'} />
						}
						<CompareRule
							ignoreEmptyValue={true}
							comparisonTarget={() => { return order.details.scheduledDisconnectDate ?? new Date('0000-01-01'); }}
							comparisonType=">="
							message="Scheduled Reconnect Date cannot be earlier than Scheduled Disconnect Date"
						/>
					</Validator>
				</DateBox>
			</Field>
		</>
	);
}
